import React from 'react';
import { Alert, StyleSheet, Text, View } from './components/base_components';
import { BusyComponent } from './components/busy_component';
import ImageButton from './components/buttons/image_button';
import TextButton from './components/buttons/text_button';
import LabelInput from './components/forms/label_input';
import CoinSelect from './components/forms/coin_select';
import ModalContent from './components/modal_content';
import TxOverlay from './components/overlays/tx_overlay';
import WalletOvelay from './components/overlays/wallet_overlay';

import CoinStore from './stores/coin_store';
import OrderHelper from './lib/order_helper';
import WalletStore from './stores/wallet_store';

import Analytics from './tools/analytics';
import util from './tools/util';

const styles = StyleSheet.create({
  buySellScreen: {
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  spinner: {
    marginTop: '2rem',
  },
  title: {
    marginTop: '2rem',
    color: 'black',
    fontSize: '2rem',
  },
  bubble: {
    marginTop: '0.5rem',
    width: '32rem',
    paddingTop: '1rem',
    paddingBottom: '1rem',
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: '#ddd',
    borderRadius: '0.5rem',
    backgroundColor: '#fff',
    flexDirection: 'column',
  },
  bubbleText: {
    marginTop: '1rem',
    marginLeft: '1rem',
    color: 'black',
    fontSize: '2rem',
  },
  topBubbleText: {
    marginTop: '1rem',
    width: '32rem',
    marginLeft: '1rem',
    color: 'black',
    fontSize: '2rem',
  },
  middle: {
    marginTop: '0.5rem',
    width: '32rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  swapButton: {
    width: '2rem',
    height: '2rem',
    padding: '1rem',
    borderRadius: '3rem',
    backgroundColor: '#0a60fe',
  },
  labelInput: {
    alignSelf: 'stretch',
  },
  totals: {
    marginTop: '1rem',
    width: '32rem',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },
  total: {
    marginTop: '0.5rem',
    paddingBottom: '0.4rem',
    paddingLeft: '0.5rem',
    paddingRight: '0.5rem',
    alignSelf: 'stretch',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderBottomColor: '#aaa',
  },
  totalText: {
    color: '#333',
    fontSize: '1.5rem',
    textAlign: 'right',
  },
  totalValue: {
    marginLeft: '1rem',
    color: '#333',
    fontSize: '1.5rem',
    fontWeight: '500',
  },
  totalSymbol: {
    marginLeft: '0.5rem',
    color: '#333',
    fontSize: '1.5rem',
  },
  actionButton: {
    marginTop: '1rem',
    width: '32rem',
  },
  spacer: {
    flex: 1,
  },
});

const SWAP_ICON = require('./assets/img/swap_white.png');
type Props = {
  isBuy: boolean;
  token: any;
  currency: any;
  quantity: string;
  price: string;
  onSwapPress: () => void;
  onTokenChange: (token: any) => void;
  onCurrencyChange: (token: any) => void;
  onQuantityChange: (quantity: string) => void;
  onPriceChange: (price: string) => void;
};
type State = {
  has_wallet: boolean;
};
export default class BuySellScreen extends BusyComponent<Props, State> {
  state = {
    has_wallet: WalletStore.hasWallet(),
  };
  _disarm = false;
  componentDidMount() {
    Analytics.showScreen('home');
    WalletStore.addChangeListener(this._onWalletUpdate);
  }
  componentWillUnmount() {
    WalletStore.removeChangeListener(this._onWalletUpdate);
  }
  _onWalletUpdate = () => {
    const has_wallet = WalletStore.hasWallet();
    this.setState({ has_wallet });
  };
  _onConnectPress = () => {
    const overlay = <WalletOvelay onDone={this._onConnectDone} />;
    ModalContent.showOverlay(overlay);
  };
  _onConnectDone = () => {
    ModalContent.hideOverlay();
    this._onWalletUpdate();
  };

  _onOrderPress = () => {
    const { token, currency } = this.props;
    const quantity = _parse(this.props.quantity);
    const price = _parse(this.props.price);
    if (!token) {
      Alert.alert('Place Order', 'Please choose both coins');
    } else if (!currency) {
      Alert.alert('Place Order', 'Please choose both coins');
    } else if (!quantity) {
      Alert.alert('Place Order', 'Please enter a quantity');
    } else if (!price) {
      Alert.alert('Place Order', 'Please enter a price');
    } else if (this.setBusy()) {
      const opts = {
        token,
        currency,
        quantity,
        price,
        is_sell: !this.props.isBuy,
      };
      OrderHelper.createOrder(opts, (err, tx_list) => {
        this.clearBusy();
        if (err) {
          Alert.alert('failed to make a tx');
        } else {
          const overlay = (
            <TxOverlay
              title='Place Order'
              data={tx_list}
              onDone={this._onTxDone}
              onSuccess={this._onTxSuccess}
              onError={this._onTxError}
            />
          );
          ModalContent.showOverlay(overlay);
        }
      });
    }
  };
  _onTxDone = () => {
    ModalContent.hideOverlay();
  };
  _onTxSuccess = (tx_hash_list: string[]) => {
    ModalContent.hideOverlay();
    window.alert('Place Order', 'Tx success: ' + tx_hash_list.pop());
  };
  _onTxError = () => {
    ModalContent.hideOverlay();
    Alert.alert('Place Order', 'Tx failed!');
  };

  render() {
    const {
      isBuy,
      token,
      currency,
      quantity,
      price,
      onSwapPress,
      onTokenChange,
      onCurrencyChange,
      onQuantityChange,
      onPriceChange,
    } = this.props;
    const { has_wallet } = this.state;
    const qty_label = isBuy ? 'Buy Quantity' : 'Sell Quantity';
    const price_label = isBuy ? 'Buy Price' : 'Sell Price';
    const top_bubble = isBuy ? 'Buy Coin' : 'Sell Coin';
    const bottom_bubble = isBuy ? 'Using Coin' : 'For Coin';

    let action = null;
    if (has_wallet) {
      action = (
        <TextButton
          style={styles.actionButton}
          text='Submit Order'
          type='default'
          onPress={this._onOrderPress}
        />
      );
    } else {
      action = (
        <TextButton
          style={styles.actionButton}
          text='Connect'
          type='default'
          onPress={this._onConnectPress}
        />
      );
    }

    let fee = '';
    let total = '';
    const quantity_num = _parse(quantity);
    const price_num = _parse(price);
    if (
      quantity &&
      price &&
      quantity_num > 0 &&
      price_num > 0 &&
      currency &&
      token
    ) {
      const opts = {
        token,
        currency,
        quantity: quantity_num,
        price: price_num,
        is_sell: !isBuy,
      };
      const { fee_wei } = OrderHelper.getTotals(opts);
      fee = CoinStore.coinAmount(fee_wei, isBuy ? currency : token);
      if (isBuy) {
        const subtotal = quantity_num * price_num;
        total = fee + subtotal;
      } else {
        fee = quantity_num * 0.01;
        total = (quantity_num - fee) * price_num;
      }
    }

    return (
      <View style={styles.buySellScreen}>
        <Text style={styles.topBubbleText}>{top_bubble}</Text>
        <View style={styles.bubble}>
          <CoinSelect
            style={styles.coinSelect}
            value={token}
            placeholder='Select Coin'
            otherCoin={currency}
            onSelect={onTokenChange}
          />
          <LabelInput
            style={styles.labelInput}
            text={qty_label}
            placeholder='Quantity'
            value={quantity}
            onChangeText={onQuantityChange}
          />
        </View>
        <View style={styles.middle}>
          <Text style={styles.bubbleText}>{bottom_bubble}</Text>
          <View style={styles.spacer} />
          <ImageButton
            style={styles.swapButton}
            source={SWAP_ICON}
            onPress={onSwapPress}
          />
        </View>
        <View style={styles.bubble}>
          <CoinSelect
            style={styles.coinSelect}
            value={currency}
            placeholder='Select Coin'
            otherCoin={token}
            onSelect={onCurrencyChange}
          />
          <LabelInput
            style={styles.labelInput}
            text={price_label}
            placeholder='Price'
            value={price}
            onChangeText={onPriceChange}
          />
        </View>
        <View style={styles.totals}>
          <Total text='Fee' value={fee} coin={isBuy ? currency : token} />
          <Total
            text={isBuy ? 'Total Spent' : 'Total Profit'}
            value={total}
            coin={currency}
          />
        </View>
        {action}
      </View>
    );
  }
}

function Total(props) {
  const { text, value, coin } = props;
  const val = value ? util.numberToDisplay(value) : '';
  const symbol = coin ? coin.symbol : '';
  return (
    <View style={styles.total}>
      <Text style={styles.totalText}>{text + ':'}</Text>
      <View style={styles.spacer} />
      <Text style={styles.totalValue}>{val}</Text>
      <Text style={styles.totalSymbol}>{symbol}</Text>
    </View>
  );
}
function _parse(value: string): number | string {
  let ret = '';
  if (value) {
    ret = parseFloat(value);
    if (isNaN(ret)) {
      ret = value;
    }
  }
  return ret;
}
